import { render, staticRenderFns } from "./PurchasedAlbum.vue?vue&type=template&id=649ca49f"
import script from "./PurchasedAlbum.vue?vue&type=script&lang=js"
export * from "./PurchasedAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports